import * as pdfjslib from "pdfjs-dist";
import fs from "src/services/config/fbConfig";

export function roundNumber(value: number, decimals: number): number {
  // return Math.round(value * Math.pow(10, decimals)) / Math.pow(10, decimals);
  return round(value, decimals);
}

export function round(value: number, decimals: number): number {
  let newNumber: number;
  const sNumber: string = value.toString();

  const increase: number = decimals + sNumber.length - sNumber.indexOf(".") + 1;

  if (value < 0) {
    newNumber = value - 5 * Math.pow(10, -increase);
  } else {
    newNumber = value + 5 * Math.pow(10, -increase);
  }

  const multiple = Math.pow(10, decimals);

  return Math.round(newNumber * multiple) / multiple;
}

export const TIMEOUT = 500;

export const TABLENAMES = {
  PROJECTS: "projects",
  STATEMENTS: "statements",
  ADVANCEDDUALRATESTATEMENTS: "advancedDualRateStatements",
  ADVANCEDSINGLERATESTATEMENTS: "advancedSingleRateStatements",
  SIMPLEDUALRATESTATEMENTS: "simpleDualRateStatements",
  SIMPLESINGLERATESTATEMENTS: "simpleSingleRateStatements",
  SERVICECHARGES: "serviceCharges",
  TAXESANDFEES: "taxesAndFees",
  GUARANTEEDPOWERTABLE: "guaranteedPowerTable",
};

export interface IPdfPage {
  pageText: string;
  words: string[];
}

export function processFile(file: File | null): Promise<IPdfPage[]> {
  return new Promise<IPdfPage[]>((resolve, reject) => {
    const pdfPages: IPdfPage[] = [];
    if (file) {
      const fileReader: FileReader = new FileReader();
      fileReader.onload = () => {
        const buffer = fileReader.result;
        pdfjslib.workerSrc = "pdfjs-dist/lib/pdf.worker.js";
        pdfjslib
          .getDocument(buffer)
          .then((doc: any) => {
            const numPages = doc._pdfInfo.numPages;
            const promises = [];
            for (let i = 1; i <= numPages; i++) {
              promises.push(
                getPageText(i, doc).then((pdfPage: any) => {
                  pdfPages.push(new PdfPage(pdfPage.pageText, pdfPage.words));
                })
              );
            }
            Promise.all(promises).then(() => {
              resolve(pdfPages);
            });
          })
          .catch((error: any) => {
            console.log(error);
            reject([]);
          });
      };
      fileReader.readAsArrayBuffer(file);
    }
  });
}
export function processFileURL(url: string): Promise<IPdfPage[]> {
  return new Promise((resolve, reject) => {
    const pdfPages: IPdfPage[] = [];
    pdfjslib.workerSrc = "pdfjs-dist/lib/pdf.worker.js";
    pdfjslib
      .getDocument(url)
      .then((doc: any) => {
        const numPages = doc._pdfInfo.numPages;
        const promises = [];
        for (let i = 1; i <= numPages; i++) {
          promises.push(
            getPageText(i, doc).then((pdfPage: any) => {
              pdfPages.push(new PdfPage(pdfPage.pageText, pdfPage.words));
            })
          );
        }
        Promise.all(promises).then(() => {
          resolve(pdfPages);
        });
      })
      .catch((error: any) => {
        console.log(error);
        reject([]);
      });
  });
}

export class PdfPage implements IPdfPage {
  public constructor(text: string, wrds: string[]) {
    this.pageText = text;
    this.words = wrds;
  }
  public pageText: string;
  public words: string[];
}

export function validatePDFFile(file: File | null): boolean {
  if (file) {
    return file.type === "application/pdf";
  }
  return false;
}

export function uploadFile(
  projectId: string,
  id: string,
  file: File | null,
  uploadCallback: any,
  uploaded: boolean
): Promise<any> {
  return new Promise<any>(resolve => {
    if (file) {
      const ref = fs.fsStorage.ref();
      const fileRef = ref.child(`projects/${projectId}/${id}.pdf`);
      // Delete before upload if it exists
      if (uploaded) {
        fileRef.delete().catch(() => console.log("does not exist."));
      }
      const upLoadTask = fileRef.put(file);
      upLoadTask.on(
        "state_changed",
        (snapshot: firebase.storage.UploadTaskSnapshot) => {
          uploadCallback(true, 0, 100, (snapshot.bytesTransferred / snapshot.totalBytes) * 100);
        },
        (error: any) => {
          console.log(error);
          uploadCallback(false, 0, 100, 100);
        },
        () => {
          const metaData = { customMetadata: { projectId, statementId: id, filename: file.name } };
          upLoadTask.snapshot.ref
            .updateMetadata(metaData)
            .then(() => {
              uploadCallback(false, 0, 100, 100);
              resolve(file);
            })
            .catch(() => {
              uploadCallback(false, 0, 100, 100);
            });
        }
      );
    }
    resolve(null);
  });
}

export interface ISearchResult {
  result: string;
  found: boolean;
  pdfPageNum: number;
  wordIndex: number;
}

export function findServiceCharges(
  pdfPages: IPdfPage[],
  startString: string,
  endString: string
): string[] {
  const words: string[] = [];
  let foundFirst: boolean = false;
  let foundLast: boolean = false;
  // tslint:disable-next-line:prefer-for-of
  for (let i = 0; i < pdfPages.length; i++) {
    const page = pdfPages[i];
    // tslint:disable-next-line:prefer-for-of
    for (let j = 0; j < page.words.length; j++) {
      const word = page.words[j];
      if (!foundFirst) {
        if (word === startString) {
          foundFirst = true;
        }
      } else {
        if (foundFirst && !foundLast) {
          if (!foundLast && word === endString) {
            foundLast = true;
          } else {
            words.push(word);
          }
        }
        if (foundFirst && foundLast) {
          break;
        }
      }
    }
    if (foundFirst && foundLast) {
      break;
    }
  }
  return words;
}

export function findAllCriterionMatches(
  pdfPages: IPdfPage[],
  criterion: string,
  returnNext: boolean,
  exact: boolean
): ISearchResult[] {
  const searchResults: ISearchResult[] = [];
  let result: string = "";
  // tslint:disable-next-line:prefer-for-of
  for (let i = 0; i < pdfPages.length; i++) {
    const page = pdfPages[i];
    // tslint:disable-next-line:prefer-for-of
    for (let j = 0; j < page.words.length; j++) {
      const word = page.words[j];
      if (exact) {
        if (word === criterion) {
          let wordIndex: number = -1;
          if (returnNext) {
            result = page.words[j + 1];
            wordIndex = j + 1;
          } else {
            result = page.words[j];
            wordIndex = j;
          }
          searchResults.push({
            result,
            found: true,
            pdfPageNum: i,
            wordIndex,
          });
        }
      } else {
        if (word.startsWith(criterion)) {
          let wordIndex: number = -1;
          if (returnNext) {
            result = page.words[j + 1];
            wordIndex = j + 1;
          } else {
            result = page.words[j];
            wordIndex = j;
          }
          searchResults.push({
            result,
            found: true,
            pdfPageNum: i,
            wordIndex,
          });
        }
      }
    }
  }
  return searchResults;
}

export function findFirstCriterionMatch(
  pdfPages: IPdfPage[],
  criterion: string,
  returnNext: boolean,
  exact: boolean
): ISearchResult {
  let found: boolean = false;
  let result: string = "";
  let pdfPageNum: number = -1;
  let wordIndex: number = -1;
  // tslint:disable-next-line:prefer-for-of
  for (let i = 0; i < pdfPages.length; i++) {
    const page = pdfPages[i];
    // tslint:disable-next-line:prefer-for-of
    for (let j = 0; j < page.words.length; j++) {
      const word = page.words[j];
      if (exact) {
        if (word === criterion) {
          if (returnNext) {
            result = page.words[j + 1];
            wordIndex = j + 1;
          } else {
            result = page.words[j];
            wordIndex = j;
          }
          pdfPageNum = i;
          found = true;
          break;
        }
      } else {
        if (word.startsWith(criterion)) {
          if (returnNext) {
            result = page.words[j + 1];
            wordIndex = j + 1;
          } else {
            result = page.words[j];
            wordIndex = j;
          }
          pdfPageNum = i;
          found = true;
          break;
        }
      }
    }
    if (found) {
      break;
    }
  }
  return {
    result,
    found,
    pdfPageNum,
    wordIndex,
  };
}

export function getPageText(pageNum: number, doc: any): Promise<any> {
  return new Promise((resolve, reject) => {
    doc
      .getPage(pageNum)
      .then((pdfPage: any) => {
        pdfPage.getTextContent().then((textContent: any) => {
          const textItems = textContent.items;
          const words: string[] = [];
          let pageText: string = "";

          // tslint:disable-next-line:prefer-for-of
          for (let i = 0; i < textItems.length; i++) {
            const item = textItems[i];
            if (item && item.str) {
              words.push(item.str);
              pageText += item.str + " ";
            }
          }

          resolve({ pageText, words });
        });
      })
      .catch((error: any) => {
        reject(error);
      });
  });
}



// WEBPACK FOOTER //
// ./src/global.tsx